import { Card, CardContent, Spinner } from '../../ui';
import { EMOTION_META, CHART_ORDER } from '../../../constants/sentiment';

const STEP_COPY = {
	queued: 'Waiting for a listening slot…',
	collecting: 'Listening to the replies…',
	labeling: 'Reading the room…',
};

export function ListeningState({ run }) {
	const collected = run?.replies?.collected || 0;
	const labeled = run?.replies?.labeled || 0;
	const totals = run?.emotions || {};
	const detected = CHART_ORDER.filter((e) => (totals[e] || 0) > 0);
	const max = Math.max(1, ...detected.map((e) => totals[e]));

	return (
		<Card>
			<CardContent className="p-6">
				<div className="flex items-center gap-3">
					<Spinner />
					<div>
						<div className="font-semibold text-foreground">{STEP_COPY[run?.status] || 'Taking the pulse…'}</div>
						<div className="text-sm text-muted-foreground">Usually a few minutes. You can leave this page - we keep listening.</div>
					</div>
				</div>
				<div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-3">
					<div><div className="text-xs uppercase tracking-wide text-muted-foreground">Posts</div><div className="text-2xl font-semibold tabular-nums">{run?.targetsCount || 0}</div></div>
					<div><div className="text-xs uppercase tracking-wide text-muted-foreground">Replies heard</div><div className="text-2xl font-semibold tabular-nums">{collected}</div></div>
					<div><div className="text-xs uppercase tracking-wide text-muted-foreground">Feelings read</div><div className="text-2xl font-semibold tabular-nums">{labeled}</div></div>
				</div>
				<div className="mt-5 space-y-1.5" aria-live="polite">
					{detected.length === 0 && <div className="text-sm text-muted-foreground">The first feelings will show up here as they're read.</div>}
					{detected.map((e) => (
						<div key={e} className="flex items-center gap-3 text-sm">
							<span className="w-28 shrink-0 text-foreground">{EMOTION_META[e].label}</span>
							<div className="h-2 flex-1 overflow-hidden rounded-full bg-muted">
								<div className={`h-full rounded-full transition-[width] duration-500 motion-reduce:transition-none ${EMOTION_META[e].bg}`} style={{ width: `${Math.round((totals[e] / max) * 100)}%` }} />
							</div>
							<span className="w-8 text-right tabular-nums text-muted-foreground">{totals[e]}</span>
						</div>
					))}
				</div>
			</CardContent>
		</Card>
	);
}
